// actions/searchQueryActions.js
export const setSearchQuery = (query) => ({
    type: "SET_SEARCH_QUERY",
    payload: query, // Pass the new value
  });
  